/**
 * Configuração do RabbitMQ STOMP
 * 
 * Variáveis de ambiente necessárias no .env:
 * REACT_APP_RABBITMQ_HOST=localhost
 * REACT_APP_RABBITMQ_STOMP_PORT=15674
 * REACT_APP_RABBITMQ_USER=admin
 * REACT_APP_RABBITMQ_PASS=admin
 * REACT_APP_RABBITMQ_VHOST=/
 * REACT_APP_RABBITMQ_DEBUG=false
 */

export const rabbitmqConfig = {
  brokerUrl: process.env.REACT_APP_RABBITMQ_HOST || 'localhost',
  username: process.env.REACT_APP_RABBITMQ_USER || 'admin',
  password: process.env.REACT_APP_RABBITMQ_PASS || 'admin',
  port: Number(process.env.REACT_APP_RABBITMQ_STOMP_PORT) || 15674,
  vhost: process.env.REACT_APP_RABBITMQ_VHOST || '/',
  queue: process.env.REACT_APP_RABBITMQ_QUEUE || 'actions.ingest.q',
  debug: process.env.REACT_APP_RABBITMQ_DEBUG !== 'false', // Debug habilitado por padrão
  autoConnect: true,
};

export const ACTIONS_QUEUE = 'actions.ingest.q';

if (process.env.NODE_ENV === 'development') {
  console.log('🐰 RabbitMQ Config:', {
    ...rabbitmqConfig,
    password: '***', 
  });
}
